<template>
  <div class="container-fluid">
    <div class="row d-flex justify-content-center my-5">
      <div class="col-11 col-md-5 mx-auto">
        <u-animate-container>
          <u-animate
            name="fadeInUp"
            delay="0s"
            duration="1s"
            :iteration="1"
            :offset="-50"
            animateClass="animated"
            :begin="false"
          >
          <h2 class="serif col-blue ">
            {{ heading }}
          </h2>
          <hr>
          <p>
            {{ description }}
          </p>
          </u-animate>
        </u-animate-container>
      </div>
    </div>
  </div>

</template>

<script>

export default {

  name: 'AddressAndInfo',
  components: {

  },
  data() {
    return {
      heading: '',
      description: '',
    }
  },
  created() {
    this.heading = this.$store.getters.getHeading
    this.description = this.$store.getters.getDescription
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
